@for (index of total | range; track index) {
  <campus-icon
    [svgIcon]="index < count ? 'star' : 'star-outline'"
  [ngClass]="{
    'ui-rating--filled': index < count,
    'icon-highlight': index < count,
    'icon-stroke-variant': index >= count,
  }"
    data-cy="icon"
  ></campus-icon>
}
